import { ProgramCard } from "src/components";
import { PromotionRow } from "src/components/promotions";
import { DateService } from "src/services";
import { ArchiveDayCardProps } from "./archive.day.card.props";

export const ArchiveDayCard: React.FC<ArchiveDayCardProps> = ({
    date, items
}) => {
    return (
        <div className="archive-list-area">
            <div className="clearfix d-flex justify-content-between align-items-end text-rtl dates-row">
                <div className="float-right text-rtl text-right program-list-date mt-4 date-start">
                    {DateService.persianDate(date, "dddd")}
                </div>
                <div className="float-left text-rtl text-left program-list-date mt-4 date-end">
                    {DateService.persianDate(date, "YYYY/M/D")}
                </div>
            </div>
            <div className="col-12 p-0">
                {
                    items.map((item, index) => (
                        item.program ? <ProgramCard {...item.program} page="archive" key={item.program.id} /> :
                            item.promotion ? <PromotionRow date={date} index={index} {...item.promotion} key={"p" + index} /> : null
                    ))
                }
            </div>
        </div>
    );
};